export const SHOP_URL = 'https://shop.jlohr.com'
